
<div class="modal-header">
  <h4 class="modal-title text-center">{{(isStake ? 'staking.claim_stake_title' : (isWithdraw ? 'staking.withdraw_title' :  'widget.claim_title')) | translate}}</h4>
</div>

<div class="modal-body text-center" *ngIf="status == SwapStatus.not_started">
  <p class="text-white text-center mb-3">{{(isStake ? 'staking.claim_stale_help' : 'widget.claim_help') | translate}}</p>
  <div class="footer">
    <button type="button" class="btn btn-primary fs-7 w-50" (click)="modalRef.hide()" translate>misc.ok</button>
  </div>
</div>

<div class="modal-body text-center" *ngIf="status == SwapStatus.in_progess">
  <img src="./assets/images/svg-icons/token.svg" alt="loading" class="statusIcon loading">
  <div class="fw-normal fw-bold font-16 px-2 my-1 text-uppercase text-light text-center">{{"widget.transaction_in_progress" | translate}}</div>
</div>

<div class="modal-body text-center" *ngIf="status == SwapStatus.complete">
  <img src="/assets/images/popup-icons/success.svg" alt="complete" class="statusIcon">
  <div class="text-white text-center mb-3" *ngIf="isClaim || isWithdraw">{{"staking.claim_success" | translate }}</div>
  <div class="text-white text-center mb-3" *ngIf="isStake">{{"staking.stake_claim_success" | translate }}</div>
  <a type="button" class="btn btn-primary fs-7 w-auto" (click)="closeModal()" translate>misc.close</a>
</div>


<div class="modal-body text-center" *ngIf="status == SwapStatus.failed || status == SwapStatus.rejected">
  <img src="./assets/images/popup-icons/warning.svg" alt="failed" class="statusIcon">
  <div class="fw-semibold font-18 my-1 text-uppercase text-danger text-center">{{"widget.transaction_failed" | translate}}</div>
  <div class="text-white font-14 text-center mb-3">{{"staking.claim_error_message" | translate }}</div>
  <a type="button" class="btn btn-primary fs-7 w-auto" (click)="closeModal()" translate>misc.close</a>
</div>